module.exports = __webpack_public_path__ + "static/sponsors-323d862753f3d979944094119406915c.jpg";